import "../polyfills";

// Ссылка на файл виджета, который необходимо загрузить
var widgetFile = process.env.ASSETS_URL + process.env.WIDGET_SCRIPT_URL;

/**
 * Ассинхронная загрука скрипта
 * @param {string} url Адрес загрузки скрипта
 * @param {Function} callback Будет выполнен после успешной загрузки скрипта
 * @param {object<string>} params Будет передан первым аргументом в callback-функцию
 * @returns {void}
 */
function loadScript(url, callback, params) {
  var tag = document.createElement("script");
  tag.src = url;
  tag.async = true;
  tag.onload = tag.onreadystatechange = function loadScriptOnLoad() {
    var readyState = tag.readyState;

    if (!readyState || /complete|loaded/.test(tag.readyState)) {
      callback(params);
    }

    tag.onload = null;
    tag.onreadystatechange = null;
  };
  tag.onerror = function () {
    throw new Error("[ArmaxPayLoader]: Не удалось загрузить скрипт " + url);
  };
  document.head.appendChild(tag);
}

/**
 * Получения значения аттрибута
 * @param {Node} elem Целевой DOM элемент
 * @param {string} name Название аттрибута
 * @returns {string}
 */
function getAttribute(name, elem) {
  var hasAttr = elem.hasAttribute(name);
  if (!hasAttr) return undefined;
  return elem.getAttribute(name);
}

/**
 * Инициализация виджета оплаты
 * @param {object} params
 * @param {string} params.terminalId ID терминала агента
 * @param {string} params.providerId ID провайдера. Если указан, виджет будет отображать только его
 * @param {Node} params.container DOM элемент контейнера для рендера виджета
 * @returns {void}
 */
function ArmaxPayLoader(params) {
  var script = params.container;
  var terminalId = Number(params.terminalId);
  var providerId = Number(params.providerId);
  var newContainer = document.createElement("div");

  newContainer.id = params.id;
  script.parentNode.replaceChild(newContainer, script);

  try {
    new window.ArmaxPayWidget({
      container: newContainer,
      terminalId: terminalId,
      providerId: providerId,
    });
  } catch (error) {
    newContainer.textContent = "Не удалось загрузить платежный виджет :(";
    throw new Error(
      "[ArmaxPayLoader]: Не удалось инициализировать ArmaxPayWidget"
    );
  }
}

/**
 * Иницизация загрузки файлов виджета оплаты
 * @param {string} id ID элемента в DOM
 * @returns {void}
 */
function initScript(selector, widgetFile) {
  var scriptElem = document.querySelector(selector);
  var terminalId;
  var providerId;

  if (scriptElem === null) {
    throw new Error("Элемент " + selector + " не найдет");
  }

  terminalId = getAttribute("data-terminal-id", scriptElem);
  providerId = getAttribute("data-provider-id", scriptElem);

  if (terminalId === null) {
    throw new Error("Не указан ID терминала");
  }

  loadScript(widgetFile, ArmaxPayLoader, {
    terminalId: terminalId,
    providerId: providerId,
    container: scriptElem,
    id: "armax-pay-loader",
  });
}

initScript("script[data-terminal-id]", widgetFile);
